export default __webpack_public_path__ + "static/media/IT.4d1aa1b3.jpg";